import React from 'react'
// import NavBar from '../Components/NavBar';
// import CarouselCategory from '../Components/CarouselCategory';
// import Footer from '../Components/Footer'
import LandingNavBar from 'components/navbar/NavBar'
import CarouselCategory from 'components/CarouselCategory'
import Footer from 'components/Footer'
import LandingFooter from 'components/Footer/landingFooter'
import HeroSection from 'components/HeroSection'

const Categories = () => {
  return (
    <>
      <LandingNavBar />
      <HeroSection>
        <h1 className='text-2xl font-bold md:text-4xl text-center align-middle capitalize"'>
          Explore a World of Knowledge
        </h1>
        <h2 className="mt-6 font-bold text-lg md:text-[24px] tracking-widest  leading-9 text-center align- capitalize">
          Choose Your Blockchain Path to <br />
          Unlock Skills Tailored to You
        </h2>
      </HeroSection>

      <CarouselCategory />
      <LandingFooter />
    </>
  )
}

export default Categories
